import type { IntegrationMethod } from "./types";

/** Backend auth/signature method names. */
export type BackendSignatureMethod = "QualifiedSignature" | "TrustedSignature";

/** Integration methods that use the signature flow (create-file-to-sign, upload-signed-file). */
export type SignedIntegrationMethod = "TrustedProfile" | "Signature";

/** Widget integration method → backend API method (create-file-to-sign, upload-signed-file). */
export const INTEGRATION_METHOD_TO_BACKEND: Record<
  SignedIntegrationMethod,
  BackendSignatureMethod
> = {
  TrustedProfile: "TrustedSignature",
  Signature: "QualifiedSignature",
};

/** Backend API method → widget integration method (from GET integration response). */
export const BACKEND_METHOD_TO_INTEGRATION: Record<
  BackendSignatureMethod,
  IntegrationMethod
> = {
  TrustedSignature: "TrustedProfile",
  QualifiedSignature: "Signature",
};

/** Type guard: true if method is TrustedProfile or Signature (uses signature flow). */
export function isSignedIntegrationMethod(
  method: IntegrationMethod | undefined
): method is SignedIntegrationMethod {
  return method != null && method in INTEGRATION_METHOD_TO_BACKEND;
}

/** Resolve backend signature method for create-file-to-sign / upload-signed-file. Returns undefined for Token/Certificate or when method is undefined. */
export function getBackendSignatureMethod(
  method: IntegrationMethod | undefined
): BackendSignatureMethod | undefined {
  return isSignedIntegrationMethod(method) ? INTEGRATION_METHOD_TO_BACKEND[method] : undefined;
}
